import yup from './default';

export const newCouponValidationSchema = yup.object().shape({
  quantity: yup.number().positive().required().default(1),
  code: yup.string().min(5).max(15),
  expirationDate: yup.date().required(),
  usesLimit: yup.number().required().default(1).positive(),
  discount: yup.number().required(),
});
